import React, { useState } from "react";
import Icon from "./Icon";
import "../styles/cta.css";

const initialForm = { name: "", email: "", company: "", message: "" };

function ContactForm() {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const whatsappNumber = "9514532527"; // Your WhatsApp number with country code

    const whatsappMessage = `
      Hello, I would like to request a demo.

      Name: ${form.name}
      Work Email: ${form.email}
      Company: ${form.company}
      What would you like to see?: ${form.message || "Not specified"}`.trim();

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappMessage,
    )}`;

    window.open(whatsappUrl, "_blank");

    setSubmitted(true);
  };

  return (
    <div className="cta-form-card">
      {submitted ? (
        <div className="cta-success">
          <div className="cta-success-icon" aria-hidden="true">
            <Icon name="check" size={22} />
          </div>
          <h3>Request received</h3>
          <p>
            Thanks, {form.name.split(" ")[0] || "there"} — we&rsquo;ll follow up
            shortly.
          </p>
        </div>
      ) : (
        <form className="cta-form" onSubmit={handleSubmit}>
          <div className="cta-field">
            <label htmlFor="cta-name">Full name</label>
            <input
              id="cta-name"
              name="name"
              type="text"
              required
              value={form.name}
              onChange={handleChange}
              placeholder="Jordan Lee"
            />
          </div>

          <div className="cta-field">
            <label htmlFor="cta-email">Work email</label>
            <input
              id="cta-email"
              name="email"
              type="email"
              required
              value={form.email}
              onChange={handleChange}
              placeholder="you@company.com"
            />
          </div>

          <div className="cta-field">
            <label htmlFor="cta-company">Company</label>
            <input
              id="cta-company"
              name="company"
              type="text"
              required
              value={form.company}
              onChange={handleChange}
              placeholder="Company name"
            />
          </div>

          <div className="cta-field">
            <label htmlFor="cta-message">
              What would you like to see? <span>(optional)</span>
            </label>
            <textarea
              id="cta-message"
              name="message"
              rows={3}
              value={form.message}
              onChange={handleChange}
              placeholder="Multi-branch attendance, payroll, Admin Dashboard…"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block">
            Request a Demo
          </button>
        </form>
      )}
    </div>
  );
}

export default ContactForm;
